import { Component, Prop, Vue } from 'vue-property-decorator';
import TileIcon from '../tile-icon/TileIcon.vue';

@Component({
    name: 'CollapsibleTile',
    components: {
      'tile-icon': TileIcon
    }
})
export default class CollapsibleTile extends Vue {
    @Prop() title!: string;
    @Prop() value = false;

    toggle() {
        this.$emit('input', !this.value);
    }
}
